import React, { useState, useEffect } from 'react';
import './InnerNav.scss';
import '../../Home/Home.scss';
import Panchang from '../../ModalPages/Panchang/Panchang';
import Calenders from '../../ModalPages/Calenders/Calenders';
import Muhurat from '../../ModalPages/Muhurat/Muhurat';
import Vrat from '../../ModalPages/Vrat/Vrat';
import Jyotish from '../../ModalPages/Jyotish/Jyotish';
import Planets from '../../ModalPages/Planets/Planets';
import Numerology from '../../ModalPages/Numerology/Numerology';
import Festivals from '../../ModalPages/Festivals/Festivals';
import Lyrics from '../../ModalPages/Lyrics/Lyrics';
import { Link } from 'react-router-dom';
import InnerHam from '../InnerHam/InnerHam';
import MenuIcon from '@mui/icons-material/Menu';


const InnerNav = () => {
  const [showPanchang, setShowPanchang] = useState(false);
  const [showCalender, setShowCalender] = useState(false);
  const [showMuhurat, setShowMuhurat] = useState(false);
  const [showVrat, setShowVrat] = useState(false);
  const [showJyotish, setShowJyotish] = useState(false);
  const [showPlanets, setShowPlanets] = useState(false);
  const [showNumerology, setShowNumerology] = useState(false);
  const [showFestivals, setShowFestivals] = useState(false);
  const [showLyrics, setShowLyrics]=useState(false);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const isAnyModalOpen =
      showPanchang ||
      showCalender ||
      showMuhurat ||
      showVrat ||
      showJyotish ||
      showPlanets ||
      showNumerology ||
      showFestivals ||
      showLyrics;

    document.body.style.overflow = isAnyModalOpen ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [
    showPanchang,
    showCalender,
    showMuhurat,
    showVrat,
    showJyotish,
    showPlanets,
    showNumerology,
    showFestivals,
    showLyrics,
  ]);

  const handleLinkClick = (openModalSetter) => {
    openModalSetter(true);
    setShowMenu(false);
  };

  return (
    <div className="inner-nav">
      {(showPanchang ||
        showCalender ||
        showMuhurat ||
        showVrat ||
        showJyotish ||
        showPlanets ||
        showNumerology ||
        showFestivals ||
        showLyrics) && <div className="blur-overlay"></div>}
      <div className="nav-content">
      <header className="header">
        <div className="logo-name">
          <span>DIVYA JYOTISA</span>
          <Link to="https://www.asthaddestiny.com/" className='link-logo'>
          <p>Discover Your True Self with Astha D Destiny.</p>
          </Link>
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={() => setShowMenu(!showMenu)}>
          <div className="bar"><MenuIcon/></div>
        </div>
        

        <ul className={`-nav ${showMenu ? 'show' : ''}`}>
          <li>
            <Link to="/" onClick={() => setShowMenu(false)}>Home</Link>
          </li>
          <li>
            <a className={showPanchang ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowPanchang)}>Panchang</a>
          </li>
          <li>
            <a className={showCalender ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowCalender)}>Calenders</a>
          </li>
          <li>
            <a className={showMuhurat ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowMuhurat)}>Muhurat</a>
          </li>
          <li>
            <a className={showVrat ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowVrat)}>Vrat</a>
          </li>
          {/* <li>
            <a className={showJyotish ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowJyotish)}>Jyotish</a>
          </li> */}
          <li>
            <a className={showPlanets ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowPlanets)}>Planets</a>
          </li>
          <li>
            <a className={showNumerology ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowNumerology)}>Numerology</a>
          </li>
          <li>
            <a className={showFestivals ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowFestivals)}>Festivals</a>
          </li>
                    <li>
            <a className={showLyrics ? 'active-trigger' : ''} onClick={() => handleLinkClick(setShowLyrics)}>Lyrics</a>
          </li>
          
          
        </ul>
      </header>

      <div className="extra-ham">
        <InnerHam/>
      </div>
      </div>

      {/* Modals */}
      {showPanchang && <Panchang onClose={() => setShowPanchang(false)} />}
      {showCalender && <Calenders onClose={() => setShowCalender(false)} />}
      {showMuhurat && <Muhurat onClose={() => setShowMuhurat(false)} />}
      {showVrat && <Vrat onClose={() => setShowVrat(false)} />}
      {showJyotish && <Jyotish onClose={() => setShowJyotish(false)} />}
      {showPlanets && <Planets onClose={() => setShowPlanets(false)} />}
      {showNumerology && <Numerology onClose={() => setShowNumerology(false)} />}
      {showFestivals && <Festivals onClose={() => setShowFestivals(false)} />}
      {showLyrics && <Lyrics onClose={()=>setShowLyrics(false)}/>}

    </div>
  );
};

export default InnerNav;
